import { render, staticRenderFns } from "./EditInteraction.vue?vue&type=template&id=2d797d3a&scoped=true&"
import script from "./EditInteraction.vue?vue&type=script&lang=js&"
export * from "./EditInteraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d797d3a",
  null
  
)

export default component.exports